import React, { useCallback } from 'react';
import { ACTION_TYPE, OP_STATUS, OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import TreatmentView from "../../../../_components/ContentOperation/TreatmentView";
import { IPropsOp } from "./";
import WrapperOperation from "./_components/WrapperOperation";
import styles from "./style.module.scss";



interface IProps extends IPropsOp {
    operationType: OPERATION_TYPE

    isOwn: boolean
    isVesselOwn: boolean
    permission: any
    status: OP_STATUS
}

const Treatment: React.FC<IProps> = (props) => {
    const { isOwn, data } = props;
    const { operation, vessel, activity_log } = data;

    const edit = useCallback(() => {

        return {
            isShow: true,
            operationType: OPERATION_TYPE.TREATMENT,
            editMode: ACTION_TYPE.EDIT,
            values: {
                activity_log,
                operation,
                vessel
            }
        }
    }, [operation, vessel, activity_log]);

    return <WrapperOperation {...{ ...props, edit }}>
        <div className={[styles['content-wrapper'], styles.layout].join(' ')}>
            <TreatmentView
                status={props.status}
                data={data}
                isOwn={isOwn}
            />
        </div>
    </WrapperOperation>;
};


export default Treatment;